import Api from 'entities/helpers/api';
import EverTrue from 'app';

/**
 * Fetches interaction purposes using Elasticsearch facets with purpose.untouched field
 *
 * @param {string} query - Optional search query to filter purposes (default: '')
 * @param {number} limit - Maximum number of results (default: 500)
 * @returns {Promise<Array<string>>} Array of purpose strings
 */
export const fetchAllInteractionPurposes = async (query = '', limit = 500) => {
  try {
    const facetQuery = {
      facet: [
        {
          field: 'purpose.untouched',
          ...(query &&
            query.trim() && {
              filter: {
                purpose: { wildcard: `*${query.trim()}*` },
              },
            }),
        },
      ],
    };

    const response = await Api.SEARCH.CONTACT_NOTE.post({
      data: JSON.stringify(facetQuery),
      params: { limit: 0 }, // Only need facet data, not documents
    });

    const facets = response?.facets?.['purpose.untouched'] || [];

    const purposes = facets
      .filter((facet) => facet.value && facet.value.trim() && facet.value.trim().length > 1)
      .slice(0, limit)
      .map((facet) => facet.value);

    return purposes;
  } catch (error) {
    EverTrue.Alert.error('Error fetching interaction purposes:', error);
    return [];
  }
};
